import ReactMarkdown from 'react-markdown';

interface MarkdownContentProps {
  content: string;
}

/** Renders markdown content with styles appropriate for the chat sidebar */
export function MarkdownContent({ content }: MarkdownContentProps): React.JSX.Element {
  return (
    <div className="prose-chat text-foreground text-sm leading-relaxed">
      <ReactMarkdown
        components={{
          p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
          strong: ({ children }) => <strong className="font-semibold text-foreground">{children}</strong>,
          em: ({ children }) => <em className="italic">{children}</em>,
          ul: ({ children }) => <ul className="mb-2 ml-4 list-disc last:mb-0">{children}</ul>,
          ol: ({ children }) => <ol className="mb-2 ml-4 list-decimal last:mb-0">{children}</ol>,
          li: ({ children }) => <li className="mb-0.5">{children}</li>,
          code: ({ children, className }) => {
            const isBlock = className?.includes('language-');
            return isBlock ? (
              <pre className="my-2 overflow-x-auto rounded bg-black/30 p-2 text-xs">
                <code>{children}</code>
              </pre>
            ) : (
              <code className="rounded bg-white/10 px-1 py-0.5 text-xs">{children}</code>
            );
          },
          pre: ({ children }) => <>{children}</>,
          h1: ({ children }) => <p className="mb-1 font-semibold">{children}</p>,
          h2: ({ children }) => <p className="mb-1 font-semibold">{children}</p>,
          h3: ({ children }) => <p className="mb-1 font-semibold">{children}</p>,
          blockquote: ({ children }) => (
            <blockquote className="my-1 border-l-2 border-muted-foreground/40 pl-2 italic">{children}</blockquote>
          ),
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer" className="text-ai underline">
              {children}
            </a>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
